<template>
    <el-form :model="roleInfo" :rules="roles" ref="roleInfo" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">模版名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="roleInfo.name" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">是否门店专用</label>
                </div>
                <div class="form-value">
                    <el-form-item>
                        <el-radio-group v-model="roleInfo.shopFlag" :disabled="isUpdate">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-form-item>
                        <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入描述" v-model="roleInfo.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    //
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-biz-event-msg-subscr-tpl-save',
        desc: '保存消息订阅模版',
        props: ['item'],
        data: function () {
            let validateName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            //
            return {
                retailerShopTagList: [],
                roleInfo: {
                    name: null,
                    shopFlag: false,
                    desc: null
                },
                isUpdate: false,
                roles: {
                    name: [{
                        validator: validateName,
                        trigger: 'blur'
                    }]
                }
            }
        },
        created: function () {
            let item = this.item;
            if(!Utils.isNoB(item) && item.id != null) {
                this.isUpdate = true;
                this.roleInfo = item;
            }
        },
        methods: {
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['roleInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        result.data = self.roleInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/bizMsg/BizEventMsgSubscrTplSave.vue